import { DatePicker, PageHeader } from 'antd'
import styled from 'styled-components'

export const TableWrapper = styled.div`
  overflow: auto;
`
export const HeaderCellWrapper = styled.th`
  border: 1px solid;
  min-width: 150px;
  text-align: center;
  background-color: #e2eff9;
  cursor: pointer;
`
export const DataCellWrapper = styled.td<{ position?: string; isError?: boolean }>`
  border: 1px solid;
  text-align: ${({ position }) => (position ? position : 'right')};
  padding: 5px;
  background-color: ${({ isError }) => isError && '#f291f1'};
`
export const AttendanceErrorWrapper = styled.div`
  margin-top: 20px;
`

export const TableCustom = styled.table`
  border: 1px solid;
`

export const PageHeaderCustom = styled(PageHeader)`
  padding-left: 0;
`

export const RangeDateWrapper = styled.div`
  display: flex;
  width: 70%;
`

export const DatePickerCustom = styled(DatePicker)`
  display: block;
  border: none !important;
`
export const Icon = styled.div`
  font-size: 19px;
  margin: 0 15px;
  display: flex;
  align-items: center;
`
export const SearchDayWrapper = styled.div`
  display: flex;
  border: 1px solid;
  width: 45%;
  justify-content: space-between;
  margin-bottom: 10px;
`
